// Тексты ошибок авторизации выбираются по коду, а не по строке сервера:
// английская строка меняется при рефакторинге и пользователю ничего не
// объясняет. Канонический список — docs/ui-auth-messages.md.
const FALLBACK = 'Не удалось связаться с сервером. Попробуйте ещё раз.'

const AUTH_MESSAGES = {
  // Один текст на все причины отказа: несуществующий адрес, отсутствующий токен
  // и неверный токен неразличимы, иначе форма работает перечислением
  // зарегистрированных адресов.
  RESET_CHALLENGE_INVALID: 'Не удалось подтвердить доступ. Проверьте адрес и токен Финтабло.',
  RESET_THROTTLED: 'Слишком много попыток. Попробуйте через 15 минут.',
  // Истекло подтверждение по токену Финтабло: начинать заново нужно с первого
  // шага того же экрана, адрес при этом сохраняется.
  RESET_TOKEN_EXPIRED: 'Время на смену пароля истекло. Начните заново — адрес мы сохранили.',
  // Ссылка из письма: одноразовая и живёт 30 минут.
  RESET_TOKEN_INVALID: 'Ссылка недействительна или уже использована. Запросите новую.',
  EMAIL_VERIFY_TOKEN_INVALID: 'Ссылка недействительна или уже использована. Запросите новую.',
  EMAIL_VERIFY_COOLDOWN: 'Письмо отправлено. Повторить можно через 2 минуты.',
  EMAIL_CHANGE_COOLDOWN: 'Письмо отправлено. Повторить можно через 2 минуты.',
  EMAIL_CHANGE_TOKEN_INVALID: 'Ссылка недействительна или уже использована. Запросите смену адреса заново.',
  // Текст объясняет правило, а не только отказывает: ограничение «один адрес —
  // один аккаунт» стоит в схеме с миграции 004, а вход читает первую строку
  // выборки по адресу, поэтому два аккаунта на адрес дали бы вход не в тот.
  EMAIL_TAKEN: 'Этот адрес уже используется другим аккаунтом. Один адрес — один аккаунт; для другой компании нужен отдельный адрес.',
  EMAIL_INVALID: 'Проверьте формат адреса.',
  EMAIL_UNCHANGED: 'Это уже ваш адрес входа.',
  CURRENT_PASSWORD_INVALID: 'Текущий пароль неверный.',
  PASSWORD_TOO_SHORT: 'Минимум 8 символов.',
  PASSWORD_UNCHANGED: 'Новый пароль совпадает с текущим.',
  CONSENT_REQUIRED: 'Подтвердите согласие на обработку персональных данных.'
}

// Экран согласия при открытии приложения. Тексты — docs/ui-auth-messages.md.
export const CONSENT_GATE_TITLE = 'Подтвердите согласие на обработку персональных данных'
export const CONSENT_GATE_HINT =
  'Чтобы продолжить работу с платформой, ознакомьтесь с условиями и подтвердите согласие. Это нужно один раз.'

// Вход и регистрация кодов не отдают — там до сих пор строка сервера, и она
// доходила до пользователя по-английски. Пока контракт этих эндпоинтов не
// меняем, известные строки переводим по значению.
const LEGACY_MESSAGES = {
  'Email already registered': 'Этот адрес уже используется другим аккаунтом. Один адрес — один аккаунт; для другой компании нужен отдельный адрес.',
  'Invalid email or password': 'Неверный адрес или пароль.',
  'email and password required': 'Заполните адрес и пароль.',
  'fintablo_token required': 'Укажите API-токен Финтабло.',
  'password must be at least 8 characters': 'Минимум 8 символов.'
}

export function translateAuthError (error) {
  return AUTH_MESSAGES[error?.code] || LEGACY_MESSAGES[error?.message] || FALLBACK
}

export const MIN_PASSWORD_LENGTH = 8
export const PASSWORD_TOO_SHORT = AUTH_MESSAGES.PASSWORD_TOO_SHORT
export const PASSWORDS_DO_NOT_MATCH = 'Пароли не совпадают.'

// Сессии после смены пароля не отзываются: JWT stateless и живёт 7 дней.
// Умолчать об этом нельзя — человек, восстанавливающий доступ после угона,
// обязан знать, что чужая сессия ещё жива.
export const OTHER_SESSIONS_NOTICE =
  'Если вы входили с других устройств, эти входы останутся активными ещё до 7 дней.'
export const PASSWORD_CHANGED =
  'Пароль изменён. Входы на других устройствах останутся активными ещё до 7 дней.'
export const PASSWORD_RESET_DONE = 'Пароль изменён, вы вошли в платформу.'

// Ответ одинаков для существующего и несуществующего адреса — иначе форма
// работает перечислением зарегистрированных адресов.
export const FORGOT_LETTER_SENT =
  'Если этот адрес зарегистрирован, мы отправили письмо со ссылкой. Ссылка действует 30 минут.'
export const EMAIL_VERIFIED = 'Адрес подтверждён.'

export function emailChangeRequested (newEmail) {
  return `Письмо отправлено на ${newEmail}. Адрес изменится после подтверждения.`
}

export function emailChangeApplied (newEmail) {
  return `Адрес входа изменён. Входите по адресу ${newEmail}.`
}

export function emailChangeCancelled (currentEmail) {
  return `Смена адреса отменена. Вход остаётся по адресу ${currentEmail}. Рекомендуем сменить пароль.`
}
